/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type DisplayBrightnessSlider_DisplayFragment = { __typename: 'Display', id: string, brightness?: { __typename: 'BrightnessState', reported: number, desired?: number | null } | null };

export type BulkUpdateBrightnessMutationVariables = Types.Exact<{
  input: Types.DisplayBulkUpdateBrightnessInput;
}>;


export type BulkUpdateBrightnessMutation = { __typename: 'Mutation', displayBulkUpdateBrightness: { __typename: 'DisplayBulkUpdateBrightnessPayload', displays: Array<{ __typename: 'Display', id: string, brightness?: { __typename: 'BrightnessState', reported: number, desired?: number | null } | null }> } };

export const DisplayBrightnessSlider_DisplayFragmentDoc = gql`
    fragment DisplayBrightnessSlider_display on Display {
  id
  brightness {
    reported
    desired
  }
}
    `;
export const BulkUpdateBrightnessDocument = gql`
    mutation BulkUpdateBrightness($input: DisplayBulkUpdateBrightnessInput!) {
  displayBulkUpdateBrightness(input: $input) {
    displays {
      id
      ...DisplayBrightnessSlider_display
    }
  }
}
    ${DisplayBrightnessSlider_DisplayFragmentDoc}`;
export type BulkUpdateBrightnessMutationFn = ApolloReactCommon.MutationFunction<BulkUpdateBrightnessMutation, BulkUpdateBrightnessMutationVariables>;

/**
 * __useBulkUpdateBrightnessMutation__
 *
 * To run a mutation, you first call `useBulkUpdateBrightnessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateBrightnessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateBrightnessMutation, { data, loading, error }] = useBulkUpdateBrightnessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateBrightnessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkUpdateBrightnessMutation, BulkUpdateBrightnessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkUpdateBrightnessMutation, BulkUpdateBrightnessMutationVariables>(BulkUpdateBrightnessDocument, options);
      }
export type BulkUpdateBrightnessMutationHookResult = ReturnType<typeof useBulkUpdateBrightnessMutation>;
export type BulkUpdateBrightnessMutationResult = ApolloReactCommon.MutationResult<BulkUpdateBrightnessMutation>;
export type BulkUpdateBrightnessMutationOptions = ApolloReactCommon.BaseMutationOptions<BulkUpdateBrightnessMutation, BulkUpdateBrightnessMutationVariables>;